import { formatDeliveryDate, deliveryDatePart } from './deliveryDateFormat'

const cartDeliveryEstimator = (data) => ({
    countries: {},
    selectedCountry: 0,
    selectedCountryActualId: 17,
    deliveryEstimate: null,
    childZones: [],
    selectedChildZone: null,
    showChildZones: false,
    loadingChildZones: false,
    
    init() {
        this.countries = Array.isArray(data?.countries) ? data.countries : []

        window.Alpine.nextTick(() => {
            const defaultCountry = window.Alpine.store('user').delivery_country_id ?? data?.defaultCountry?.toString()
            const foundIndex = defaultCountry ? this.getIndex(defaultCountry) : -1
            
            // Use found index if valid, otherwise default to first item (index 0)
            this.selectedCountry = foundIndex >= 0 ? foundIndex : 0
        })
        window.Alpine.nextTick(() => {
            if (this.countries.length > 0) {
                this.updateEstimates();
            }
        });
    },

    async updateEstimates(cartDates) {
        if (cartDates && Array.isArray(cartDates.countries)) {
            this.countries = cartDates.countries
        }

        const selectedCountryData = this.countries[this.selectedCountry]
        if (!selectedCountryData) {
            console.warn('No country data found for index:', this.selectedCountry)
            return
        }

        this.deliveryEstimate = selectedCountryData.deliveryDate
        this.selectedCountryActualId = parseInt(selectedCountryData.id_country, 10)
        
        // Need to parse has_child_zones since it comes through as string sometimes
        this.showChildZones = parseInt(selectedCountryData.has_child_zones, 10) === 1
        
        if (this.showChildZones) {
            await this.loadChildZones(this.selectedCountryActualId)
        } else {
            this.childZones = []
            this.selectedChildZone = null
        }
    },

    async loadChildZones(id_country) {
        this.loadingChildZones = true
        
        try {
            const response = await window.api.get(`/m/accu/countryChildZones?id_country=${id_country}`)
            this.childZones = response.data.child_zones || []
            
            // Default to first zone and update delivery date
            if (this.childZones.length > 0) {
                this.selectedChildZone = 0
                this.updateDeliveryEstimateFromChildZone()
            }
        } catch (error) {
            console.error('Error loading child zones:', error)
            this.childZones = []
        } finally {
            this.loadingChildZones = false
        }
    },
    
    updateDeliveryEstimateFromChildZone() {
        if (this.selectedChildZone !== null && this.childZones[this.selectedChildZone]) {
            const selectedZone = this.childZones[this.selectedChildZone]
            this.deliveryEstimate = selectedZone.deliveryDate
        }
    },

    // e.g. "Saturday 24 October", with the year only when it isn't this year
    formatDeliveryDate(locale) {
        return this.deliveryEstimate ? formatDeliveryDate(this.deliveryEstimate, locale) : ''
    },

    // One part of the date for the calendar tile: the short month ("Oct") or the day ("24")
    deliveryDatePart(locale, part) {
        return this.deliveryEstimate ? deliveryDatePart(this.deliveryEstimate, locale, part) : ''
    },

    /** @param {string} id_country */
    getIndex(id_country) {
        return this.countries.findIndex(
            c => c.id_country == id_country
        );
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('cartDeliveryEstimator', cartDeliveryEstimator)
})
